export default "__VITE_ASSET__981c683d__"